// src/i18n/tictactoe.js

export const translations = {
  es: {
    selectMode: "Selecciona el modo de criterios",
    playLocal: "🧍 En local (2 jugadores)",
    playBot: "🤖 Contra BOT",
    classic: "Clásico (Aleatorio)",
    dynamic: "Dinámico desde 1980",
    mode2000: "Modo 2000+",
    historic: "Histórico 1980–1999",
    whoPlay: "¿Contra quién quieres jugar?",
    back: "← Volver atrás",
    playGrid: "Modo libre (solo jugador X)",
    selectGameType: "Elige tipo de partida",
    normalMode: "Modo normal",
    teamsOnlyMode: "Solo equipos / nacionalidades",

  },
  en: {
    selectMode: "Select criteria mode",
    playLocal: "🧍 Local (2 players)",
    playBot: "🤖 Play vs BOT",
    classic: "Classic (Random)",
    dynamic: "Dynamic from 1980",
    mode2000: "Mode 2000+",
    historic: "Historic 1980–1999",
    whoPlay: "Who do you want to play against?",
    back: "← Go back",
    playGrid: "Grid Mode",
    selectGameType: "Choose game type",
    normalMode: "Normal mode",
    teamsOnlyMode: "Teams / nationalities only",
  }
};
